/**
 * El peso de la carga, escrito como se lee en Colombia.
 *
 * 🚨 Esto existe por una trampa medida: Vulcano manda el peso en TONELADAS y la
 * base lo guarda con tres decimales, así que sale como `'28.000'` y `'15.800'`.
 * Son 28 y 15,8 toneladas — pero acá el punto es el separador de MILES, y
 * puesto tal cual el conductor lee «veintiocho mil toneladas» en la lista y el
 * cliente lo lee igual en el cumplido.
 *
 * Vive en el paquete compartido para que la app del conductor y el documento
 * del cliente escriban SIEMPRE lo mismo. Si se toca, se toca en un solo lugar.
 */
/**
 * 🚨 El formateador se crea UNA vez, no en cada llamada.
 *
 * `new Intl.NumberFormat(...)` es caro: medido, crearlo 223 veces cuesta 23 ms
 * y reusarlo 0,5 ms — **45 veces más lento**. Y esto se llama una vez por fila
 * y por cada pintada de la lista, que son 223 filas.
 */
const FORMATO = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 2 })

export function pesoLegible(ton: string | number | null | undefined): string | null {
  if (ton === null || ton === undefined || ton === '') return null
  const n = typeof ton === 'number' ? ton : Number(ton)
  if (!Number.isFinite(n) || n <= 0) return null
  // Hasta 2 decimales: 16,05 t es un peso real; 16,047 no aporta nada.
  return `${FORMATO.format(n)} t`
}
